import React, { useEffect } from 'react';
import './Product.css';
import { useStateValue } from './StateProvider';
import Aos from "aos";
import "aos/dist/aos.css";

function Product({ id, title, image, price, rating }) {
    useEffect(() => {
        Aos.init({duration:1000});
    }, [] );
    const [{basket}, dispatch] = useStateValue();
    
    const addToBasket = () => {
        dispatch({
            type: "ADD_TO_BASKET",
            item: {
                id:id,
                title:title,
                image:image,
                price:price,
                rating:rating,
            },
        });
    };

    return (
        
        <div data-aos="fade-up"
         className='product'>
            
            <img src={image} alt=""  />
            
            <div className='product__info'>
                <p> {title}
                </p>
                <p className='product__price'>
                    <small>₹</small>
                    <strong>{price}</strong>
                </p>
                <div className='product__rating'>
                    {Array(rating).fill().map((_, i)=> (
                        <p>⭐</p>
                    ))}
                    
                   
                </div>
            </div>
            <button onClick={addToBasket} >Add to Basket</button>
        </div>
    )
}

export default Product;
